/** Carriers sahifalari lug'ati (uz). */
export default {
  title: "Carrier'lar",
  subtitle_one: "{{count}} ta carrier · statistika: {{scope}}",
  subtitle_other: "{{count}} ta carrier · statistika: {{scope}}",
  newCarrier: "+ Yangi carrier",
  filters: {
    status: "Holat",
    statusAll: "Holat: hammasi",
    hiringState: "Yollash shtati",
    hiringAny: "Yollash shtati: istalgan",
    trucks: "Trucklar",
    trucksAll: "Har qanday truck",
    trucksAvailable: "Bo'sh truck bor",
    trucksExpiring: "Truck hujjati muddati yaqin",
    trucksAny: "Truck'i bor",
    openOnly: "Faqat ochiq vakansiyalar",
    searchPlaceholder: "Nom, MC, kontakt bo'yicha qidirish",
    searchAria: "Carrier'larni qidirish",
  },
  empty: {
    filtered: "Bu filtrlarga mos carrier yo'q",
    none: "Hali carrier'lar yo'q",
    manager: "Haydovchilarni joylashtiradigan yuk tashish kompaniyalarini qo'shing.",
    viewer: "Carrier'larni menejeringiz qo'shadi.",
  },
  columns: {
    name: "Nomi",
    mcDot: "MC / DOT",
    status: "Holat",
    mainContact: "Asosiy kontakt",
    hiringStates: "Yollash shtatlari",
    openJobs: "Ochiq vakansiyalar",
    freeTrucks: "Bo'sh truck",
    submitted: "Topshirilgan",
    hired: "Yollangan",
    rejection: "Rad etish",
    driver: "Haydovchi",
    recruiter: "Recruiter",
    job: "Vakansiya",
    date: "Sana",
    states: "Shtatlar",
    experience: "Tajriba",
    pay: "Maosh",
    homeTime: "Uyga qaytish",
    equipment: "Texnika",
    candidates: "Nomzodlar",
    carrierReply: "Carrier javobi",
    decided: "Qaror sanasi",
  },
  pagination: { carriers: "carrier", candidates: "nomzod" },
  scope: { allBranches: "barcha filiallar", yourBranch: "sizning filialingiz", myDrivers: "mening haydovchilarim" },
  states48: "48 shtat",
  withdrawn: "Qaytarib olingan",
  rejectedWith: "Rad etilgan · {{reason}}",
  reply: {
    noReply_one: "javob yo'q · {{count}} kun",
    noReply_other: "javob yo'q · {{count}} kun",
    waiting_one: "kutilmoqda · {{count}} kun",
    waiting_other: "kutilmoqda · {{count}} kun",
    started: "ish boshladi: {{date}}",
  },
  profile: {
    notFound: "Carrier topilmadi.",
    statusToast: { active: "Carrier qayta faollashtirildi", paused: "Carrier to'xtatib turildi", stopped: "Carrier to'xtatildi" },
    updateFailed: "Carrier'ni yangilab bo'lmadi",
    hiringIn: "Yollaydi: {{states}}",
    mainContact: "Asosiy kontakt:",
    pause: "To'xtatib turish",
    resume: "Davom ettirish",
    newJob: "+ Yangi vakansiya",
    resumeFirst: "Avval carrier'ni qayta faollashtiring",
    tabs: { overview: "Umumiy", jobs: "Vakansiyalar ({{count}})", candidates: "Nomzodlar ({{count}})", trucks: "Trucklar ({{count}})", trucksFree: "Trucklar ({{count}} · {{free}} bo'sh)", notes: "Izohlar" },
    kpi: {
      submitted: "Topshirilgan",
      hired: "Yollangan",
      rejectionRate: "Rad etish ulushi",
      openJobs: "Ochiq vakansiyalar",
      allTime: "butun davr · {{scope}}",
      ofSubmitted: "topshirilganlarning {{pct}}%",
      noSubmissions: "hali topshiriqlar yo'q",
      rejectedOf: "{{submitted}} tadan {{rejected}} tasi rad etilgan",
      carrierStatus: "carrier {{status}}",
      jobsTotal_one: "jami {{count}} ta vakansiya",
      jobsTotal_other: "jami {{count}} ta vakansiya",
    },
    openJobs: "Ochiq vakansiyalar ({{count}})",
    allJobs: "Barcha vakansiyalar →",
    noOpenJobs: "Ochiq vakansiyalar yo'q.",
    topReasons: "Asosiy rad etish sabablari",
    inScope: "doira: {{scope}}",
    noRejections: "Hali rad etishlar yo'q.",
    recentCandidates: "So'nggi nomzodlar",
    allCandidates: "Barcha nomzodlar →",
    noCandidatesForCarrier: "Bu carrier'ga hali nomzod topshirilmagan.",
    noJobs: "Bu carrier'da vakansiyalar yo'q",
    candidatesCount_one: "{{count}} ta nomzod",
    candidatesCount_other: "{{count}} ta nomzod",
    hiredOf: "{{openings}} o'rindan {{hired}} tasi yollangan",
    noCandidatesYet: "Hali nomzodlar yo'q",
    noCandidatesHint: "Bu carrier vakansiyalariga topshirilgan haydovchilar shu yerda ko'rinadi.",
    notesTitle: "Izohlar va topshirish",
    submissionMethod: "Topshirish usuli",
    replyTime: "Javob muddati",
    hiringStates: "Yollash shtatlari",
    added: "Qo'shilgan",
    notes: "Izohlar",
    noNotes: "Izoh yo'q. Menejerlar bu carrier haydovchilarni qanday qabul qilishini yozib qo'yishi mumkin.",
    resumeQ: "{{name}} qayta faollashtirilsinmi?",
    pauseQ: "{{name}} to'xtatib turilsinmi?",
    resumeDesc: "Bu carrier'ga yana haydovchi topshirish mumkin bo'ladi. Yopilgan vakansiyalar siz qayta ochmaguncha yopiq qoladi.",
    pauseDesc: "Ochiq vakansiyalar yopiladi va haydovchi topshirib bo'lmaydi. Jarayondagi nomzodlarga ta'sir qilmaydi.",
    pauseCarrier: "Carrier'ni to'xtatib turish",
    openJobsNow_one: "Hozir {{count}} ta ochiq vakansiya bor.",
    openJobsNow_other: "Hozir {{count}} ta ochiq vakansiya bor.",
  },
  form: {
    nameRequired: "Carrier nomi majburiy.",
    placementFee: "Har ishga olingan driver uchun to'lov ($)",
    placementFeeHint: "Har yangi ishga olishga standart bo'lib tushadi",
    mcRequired: "MC raqami majburiy.",
    saved: "Carrier saqlandi",
    created: "Carrier yaratildi",
    saveFailed: "Carrier'ni saqlab bo'lmadi.",
    editTitle: "Carrier'ni tahrirlash",
    newTitle: "Yangi carrier",
    name: "Carrier nomi",
    mc: "MC №",
    dot: "DOT №",
    status: "Holat",
    mainContact: "Asosiy kontakt",
    phone: "Telefon",
    email: "Email",
    city: "Shahar",
    state: "Shtat",
    replyTime: "Javob muddati",
    replyPlaceholder: "odatda 3 ish kuni",
    hiringStates: "Yollash shtatlari",
    all48: "Barcha 48 shtat",
    pickStates: "Bu carrier yollaydigan shtatlarni tanlang",
    submissionMethod: "Topshirish usuli",
    submissionHint: "Haydovchilar qanday yuboriladi: email paket, Tenstreet, carrier portali...",
    submissionPlaceholder: "email paket",
    notes: "Izohlar",
    notesPlaceholder: "Dallasdan 150 mil radiusdagi haydovchilarni afzal ko'radi",
  },
  trucks: {
    add: "Truck qo'shish",
    newTitle: "Yangi truck",
    editTitle: "Truck {{unit}}",
    created: "Truck qo'shildi",
    saved: "Truck saqlandi",
    saveFailed: "Truck saqlanmadi",
    statusSet: "Holat: {{status}}",
    archiveTitle: "Truck {{unit}} arxivlansinmi?",
    archiveDesc: "Ro'yxat va sonlardan chiqadi. Tarixi qoladi, qayta tiklash mumkin.",
    archived: "Truck arxivlandi",
    expired: "o'tgan",
    noDriver: "Driver yo'q",
    freeCount_one: "{{count}} ta bo'sh truck",
    freeCount_other: "{{count}} ta bo'sh truck",
    expiringCount_one: "{{count}} ta truck: hujjat muddati yaqin",
    expiringCount_other: "{{count}} ta truck: hujjat muddati yaqin",
    empty: "Hali truck yo'q",
    emptyFiltered: "Bu holatda truck yo'q",
    emptyManager: "Carrierning trucklarini qo'shing: bo'sh truck — carrierga driver kerak degani.",
    emptyViewer: "Trucklarni menejer yoki owner qo'shadi.",
    chips: { all: "Hammasi" },
    cols: { truck: "Truck", trailer: "Treyler", status: "Holat", driver: "Driver", location: "Joylashuv", plate: "Raqam · VIN", insurance: "Sug'urta", inspection: "Inspeksiya" },
    sections: { basic: "Truck", trailer: "Treyler", registration: "Ro'yxat va muddatlar", location: "Joylashuv va driver" },
    f: {
      unit: "Unit #", status: "Holat", statusHint: "Driver bo'lsa truck — Band", year: "Yil", make: "Marka", model: "Model", cab: "Kabina", transmission: "Uzatma",
      trailerType: "Treyler turi", trailerLength: "Uzunligi (fut)", plate: "Davlat raqami", plateState: "Raqam shtati", insurance: "Sug'urta muddati",
      inspection: "Yillik inspeksiya muddati", inspectionHint: "DOT yillik inspeksiyasi", city: "Shahar", state: "Shtat", crew: "Solo / team",
      driver: "Driver", coDriver: "Ikkinchi driver (team)", noDriver: "Driver yo'q", noHired: "Bu carrierga hali driver ishga olinmagan", notes: "Izoh",
    },
    cab: { sleeper: "Sleeper (yotoqli)", day_cab: "Day cab" },
    transmission: { automatic: "Avtomat", manual: "Mexanik" },
    crew: { solo: "Solo", team: "Team" },
    trailer: { dry_van: "Dry van", reefer: "Reefer (muzlatkich)", flatbed: "Flatbed", step_deck: "Step deck", conestoga: "Conestoga", tanker: "Tanker", power_only: "Power only", box_truck: "Box truck", car_hauler: "Car hauler", other: "Boshqa" },
  },
};
